// Centralised test ids for Alvora OS
export const TEST_IDS = {
  // Auth
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-button',
  loginForgot: 'login-forgot-link',
  loginError: 'login-error-message',
  logoutButton: 'logout-button',

  // Password reset
  resetSubmit: 'reset-submit-button',
  resetEmail: 'reset-email-input',

  // Sidebar / nav
  sidebar: 'app-sidebar',
  navDashboard: 'nav-dashboard',
  navProjects: 'nav-projects',
  navEstimating: 'nav-estimating',
  navPurchasing: 'nav-purchasing',
  navInvoices: 'nav-invoices',
  navLabour: 'nav-labour',
  navFinancial: 'nav-financial',
  navStaff: 'nav-staff',
  navReports: 'nav-reports',
  navSettings: 'nav-settings',
  mobileMenuToggle: 'mobile-menu-toggle',

  // Dashboard
  dashboard: 'dashboard-page',
  kpiContractedValue: 'kpi-contracted-value',
  kpiActiveProjects: 'kpi-active-projects',
  kpiForecastMargin: 'kpi-forecast-margin',
  kpiOutstandingInvoices: 'kpi-outstanding-invoices',
  kpiLabourWeek: 'kpi-labour-this-week',
  createFirstProject: 'create-first-project-button',

  // Projects
  projectsPage: 'projects-page',
  projectsSearch: 'projects-search-input',
  projectsTable: 'projects-table',
  projectRow: 'project-row',
  newProjectButton: 'new-project-button',

  // New Project dialog
  newProjectDialog: 'new-project-dialog',
  npName: 'new-project-name',
  npCode: 'new-project-code',
  npClient: 'new-project-client',
  npType: 'new-project-type',
  npContractValue: 'new-project-contract-value',
  npVat: 'new-project-vat',
  npStartDate: 'new-project-start-date',
  npEndDate: 'new-project-end-date',
  npSubmit: 'new-project-submit',
  npCancel: 'new-project-cancel',

  // Project detail
  projectDetail: 'project-detail-page',
  tabOverview: 'tab-overview',
  tabBoq: 'tab-boq',
  tabCosts: 'tab-costs',
  tabLabour: 'tab-labour',
  tabPurchasing: 'tab-purchasing',
  tabInvoices: 'tab-invoices',
  tabVariations: 'tab-variations',
  tabProgramme: 'tab-programme',
  tabDocuments: 'tab-documents',
  tabReports: 'tab-reports',
};
